import React from 'react'
import { Button, Col, Form, InputGroup, Modal } from 'react-bootstrap'
import { FaFacebookF, FaLinkedin, FaPinterest, FaReddit } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'
import { ImWhatsapp } from 'react-icons/im'
import { IoMdMail } from 'react-icons/io'

const ShairModal = ({ Show, Hide, Size }) => {
    const url = "https://galaxshorts.com/shorts/9uwn9D2Zifw?si=VNzl76v5VY";

    const copyToClipboard = () => {
        navigator.clipboard.writeText(url);
        alert("URL copied to clipboard!")
    }

    return (
        <div>
            <Modal
                show={Show}
                onHide={Hide}
                size={Size}
                backdrop="static"
                keyboard="false"
            >
                <Modal.Body className="text_light bg-dark">
                    <Form.Group as={Col} md={12} sm={12} className="mt-4">
                        <div className="hstack justify-content-end cursor-pointer" onClick={Hide}>
                            <span className="skip-text">Skip For Now</span>
                        </div>
                        <div className="hstack gap-2 mb-3 cursor-pointer">
                            <div className="text-center bg-dark p-3" style={{ width: 120, borderRadius: 10 }}>
                                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        backgroundColor: "#32CD32",
                                    }}
                                >
                                    <ImWhatsapp className="text-white fs-25" />
                                </div>
                                <div className="text-white fs-14">
                                    Whatsapp
                                </div>
                            </div>
                            <div className="text-center bg-dark p-3" style={{ width: 120, borderRadius: 10 }}>
                                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        backgroundColor: "#000",
                                    }}
                                >
                                    <FaXTwitter className="text-white fs-25" />
                                </div>
                                <div className="text-white fs-14">
                                    Twitter
                                </div>
                            </div>
                            <div className="text-center bg-dark p-3" style={{ width: 120, borderRadius: 10 }}>
                                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        backgroundColor: "#6495ED",
                                    }}
                                >
                                    <FaFacebookF className="text-white fs-25" />
                                </div>
                                <div className="text-white fs-14">
                                    FaceBook
                                </div>
                            </div>
                            <div className="text-center bg-dark p-3" style={{ width: 120, borderRadius: 10 }}>
                                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        backgroundColor: "#A9A9A9",
                                    }}
                                >
                                    <IoMdMail className="text-white fs-25" />
                                </div>
                                <div className="text-white fs-14">
                                    Mail
                                </div>
                            </div>

                            <div className="text-center bg-dark p-3" style={{ width: 120, borderRadius: 10 }}>
                                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        backgroundColor: "#FF5733 ",
                                    }}
                                >
                                    <FaReddit className="text-white fs-25" />
                                </div>
                                <div className="text-white fs-14">
                                    Reddit
                                </div>
                            </div>


                            <div className="text-center bg-dark p-3" style={{ width: 120, borderRadius: 10 }}>
                                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        backgroundColor: "#FFC300",
                                    }}
                                >
                                    <FaPinterest className="text-white fs-25" />
                                </div>
                                <div className="text-white fs-14">
                                    Pinterest
                                </div>
                            </div>

                            <div className="text-center bg-dark p-3" style={{ width: 120, borderRadius: 10 }}>
                                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        backgroundColor: "#87CEEB",
                                    }}
                                >
                                    <FaLinkedin className="text-white fs-25" />
                                </div>
                                <div className="text-white fs-14">
                                    Linkdin
                                </div>
                            </div>

                        </div>
                        <div className="mx-3">
                            <Form.Group>
                                <InputGroup>
                                    <Form.Control type="text" placeholder="url" className="bg-dark profileFormControl p-2 text-white border-secondary" value={url} readOnly />
                                    <Button variant="primary" onClick={copyToClipboard} className="border-secondary" >
                                        Copy
                                    </Button>
                                </InputGroup>
                            </Form.Group>
                        </div>
                    </Form.Group>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ShairModal;